import React from 'react';
import { useTheme } from '../ThemeContext';

const Calendar = () => {
    const { isDarkMode } = useTheme();

    return (
        <div className={isDarkMode ? 'min-h-screen bg-slate-800 text-amber-100' : 'min-h-screen bg-amber-100 text-slate-800'}>
        {/* Header */}
        <header className="relative pt-40 transition-all duration-500 ease-in-out">
            <div className="flex flex-col items-center mx-auto relative z-10">
            <div className="flex flex-col md:text-8xl text-6xl font-semibold">
                <h1 className="">Calendar</h1>
            </div>
            </div>
        </header>

        {/* Main Content */}
        <main className="flex flex-col items-center mx-auto px-10 transition-all duration-500 ease-in-out">
            <div className="md:w-2/3 my-8 md:p-10 p-2 shadow-[0.625rem_0.625rem_0.875rem_0_rgb(225,226,228),-0.5rem_-0.5rem_1.125rem_0_rgb(255,255,255)]">
                <iframe title="Keebs Calendar" src="https://calendar.google.com/calendar/embed?src=da6dc78bf77d85208d027cf57d84b2099a96e4d706771af6e9f8048066340826%40group.calendar.google.com&ctz=America%2FLos_Angeles" 
                frameborder="0" onmousewheel="" width="100%" height="550" className="filter bg-transparent border-1;"></iframe>
            </div>
        </main>

        </div>
    );
};

export default Calendar;
